import { mapDispatchToProps, mapStateToProps } from './VerifyTOTP.container';

import { Box } from '@mui/material';
import { FormikTextField } from '/b2b/common/components/FormControls/TextField';
import FormikValidationForm from '/b2b/common/components/organisms/FormikValidationForm';
import PropTypes from 'prop-types';
import React from 'react';
import ReselectMFA from '../components/ReselectMFA';
import { connect } from 'react-redux';
import { verifyTotpSchema } from './VerifyTOTP.schema';

// eslint-disable-next-line no-use-before-define
export default connect(mapStateToProps, mapDispatchToProps)(VerifyTOTP);

/**
 * This component handles the TOTP verification process. Although it CAN be used to verify a TOTP MFA code, it should not be
 * because of differing nomenclature and user experience.
 *
 * TOTP MFA codes are verified through the [SignInConfirm]({@link ./../../SignIn/SignInConfirm/SignInConfirm.component.jsx}) component
 */
export function VerifyTOTP(props) {
    const { verify } = props;
    return (
        <Box
            display="flex"
            flexDirection="column"
            height="100%"
            alignItems="stretch"
            justifyContent="center"
            sx={{ mx: 'auto', px: 2, maxWidth: 700, width: '100%' }}
        >
            <FormikValidationForm
                enableReinitialize
                validateOnMount
                initialValues={{}}
                validationSchema={verifyTotpSchema}
                onSubmit={verify}
                title="auth.signIn.confirm.title"
                subtitle="auth.totp.confirmationCode.description"
                submitText="auth.signIn.continue"
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    width="100%"
                    flexGrow={1}
                    gap={0.5}
                    alignItems="center"
                    mt={4}
                    mb={1}
                    sx={theme => (theme.breakpoints.down('lg') ? { justifyContent: 'center' } : {})}
                >
                    <FormikTextField
                        name="code"
                        label="common.fields.code.label"
                        autoComplete="off"
                        placeholder="auth.amplify.mfa.totp.placeholder"
                        fullWidth
                        required
                        mb={1}
                    />
                </Box>
            </FormikValidationForm>
            <ReselectMFA mfaType="TOTP" />
        </Box>
    );
}

VerifyTOTP.propTypes = {
    verify: PropTypes.func.isRequired,
};
